export default __webpack_public_path__ + "static/media/service-5.06c864e2.jpeg";